import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-174b91ef"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hero" }
const _hoisted_2 = { class: "hero-body" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "header is-flex is-justify-content-space-between" }
const _hoisted_6 = { class: "title is-4" }
const _hoisted_7 = { class: "subtitle is-6 has-text-grey" }
const _hoisted_8 = { class: "content-body" }
const _hoisted_9 = {
  key: 0,
  class: "table"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Id", -1))
const _hoisted_11 = { class: "" }
const _hoisted_12 = { class: "" }
const _hoisted_13 = { class: "header" }
const _hoisted_14 = { class: "title is-5" }
const _hoisted_15 = { class: "field" }
const _hoisted_16 = { class: "label" }
const _hoisted_17 = { class: "control" }
const _hoisted_18 = { class: "field" }
const _hoisted_19 = { class: "label" }
const _hoisted_20 = { class: "control" }
const _hoisted_21 = { class: "columns" }
const _hoisted_22 = { class: "column" }
const _hoisted_23 = { class: "field" }
const _hoisted_24 = { class: "label" }
const _hoisted_25 = { class: "control" }
const _hoisted_26 = { class: "column" }
const _hoisted_27 = { class: "field" }
const _hoisted_28 = { class: "label" }
const _hoisted_29 = { class: "control" }
const _hoisted_30 = { class: "field is-grouped is-grouped-right" }
const _hoisted_31 = { class: "control" }
const _hoisted_32 = {
  type: "submit",
  class: "button is-primary"
}
const _hoisted_33 = { class: "control" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_UserTableRow = _resolveComponent("UserTableRow")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Navbar),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", null, [
                _createElementVNode("h4", _hoisted_6, _toDisplayString(_ctx.$t('message.backend')), 1),
                _createElementVNode("h6", _hoisted_7, _toDisplayString(_ctx.$t('message.createUpdateYourUsers')), 1)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("button", {
                  class: "button is-primary",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleCreating && _ctx.toggleCreating(...args)))
                }, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.$t('message.newUser')), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              (!_ctx.creating)
                ? (_openBlock(), _createElementBlock("table", _hoisted_9, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _hoisted_10,
                        _createElementVNode("th", null, _toDisplayString(_ctx.$t('message.image')), 1),
                        _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t('message.specialistName')), 1),
                        _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t('message.email')), 1),
                        _createElementVNode("th", null, _toDisplayString(_ctx.$t('message.operations')), 1)
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getUsers, (user) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: user.user_id
                        }, [
                          _createVNode(_component_UserTableRow, { "user-data": user }, null, 8, ["user-data"])
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.creating)
                ? (_openBlock(), _createElementBlock("form", {
                    key: 1,
                    onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.create && _ctx.create(...args)), ["prevent"]))
                  }, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("h5", _hoisted_14, _toDisplayString(_ctx.$t('message.createNewSpecialist')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('message.description')), 1),
                      _createElementVNode("div", _hoisted_17, [
                        _withDirectives(_createElementVNode("input", {
                          minlength: "2",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newUser.name) = $event)),
                          class: "input",
                          type: "text",
                          placeholder: "e.g Alex Smith",
                          required: ""
                        }, null, 512), [
                          [_vModelText, _ctx.newUser.name]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t('message.email')), 1),
                      _createElementVNode("div", _hoisted_20, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newUser.email) = $event)),
                          class: "input",
                          type: "email",
                          placeholder: "e.g. alexsmith@gmail.com",
                          required: ""
                        }, null, 512), [
                          [_vModelText, _ctx.newUser.email]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t('message.backendPassword')), 1),
                          _createElementVNode("div", _hoisted_25, [
                            _withDirectives(_createElementVNode("input", {
                              minlength: "6",
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newUser.password) = $event)),
                              class: "input",
                              type: "password",
                              required: ""
                            }, null, 512), [
                              [_vModelText, _ctx.newUser.password]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.$t('message.confirmation')), 1),
                          _createElementVNode("div", _hoisted_29, [
                            _withDirectives(_createElementVNode("input", {
                              minlength: "6",
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newUser.confirmation) = $event)),
                              class: "input",
                              type: "password",
                              required: ""
                            }, null, 512), [
                              [_vModelText, _ctx.newUser.confirmation]
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("p", _hoisted_31, [
                        _createElementVNode("button", _hoisted_32, _toDisplayString(_ctx.$t('message.save')), 1)
                      ]),
                      _createElementVNode("p", _hoisted_33, [
                        _createElementVNode("a", {
                          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.toggleCreating && _ctx.toggleCreating(...args))),
                          class: "button is-light"
                        }, _toDisplayString(_ctx.$t('message.cancel')), 1)
                      ])
                    ])
                  ], 32))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ], 64))
}